import { graphql } from 'relay-runtime'

export const getCities = graphql`
  query getCities_Query($ids: [Int!]!) {
    cities: batchGetCities(ids: $ids) {
      name
    }
  }
`
